const NUMBER = 'number';
export default function(value, options = {}) {
    const localValue = typeof value === NUMBER ? String(value) : value;

    if (localValue) {
        const cleanedAmount = localValue.replace(/[^0-9,.-]+/g, '');

        // Заменяем запятую на точку для корректного преобразования в число
        const amount = parseFloat(cleanedAmount.replace(',', '.'));

        // Форматируем число по локали
        const formatted = amount.toLocaleString('uk-UA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            ...options
        });

        // Заменяем запятую на точку в дробной части
        return formatted.replace(',', '.');
    } else return '';
}
